export { default } from "./PricingDetails";
